import React from 'react';
import { AppBar, Box, IconButton, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { MobileMenuDrawer } from './MobileMenuDrawer';
import { DesktopMenuDrawer } from './DesktopMenuDrawer';

import { CustomTheme } from '../../../../types/customTheme/customTheme';
import { useLoadTheme } from '../../../../config/loadThemeFromJson';

export const HeaderEscolaLegislativoMenu: React.FC = () => {
  const theme = useLoadTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const headerMenu = theme.custom?.headerSiteMenu || {};
  const nome = theme.custom?.nome || 'Nome Padrão';

  const backgroundColorMobile = headerMenu.backgroundColorMobile || '#000000';
  const textColorMobile = headerMenu.textColorMobile || '#ffffff';
  const textColorDesktop = headerMenu.textColorDesktop || '#000000';

  const headerTitleStyle = theme.typography?.headerTitle || {
    fontSize: '0.875rem',
    fontWeight: 700
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: isMobile ? backgroundColorMobile : 'transparent',
        color: isMobile ? textColorMobile : textColorDesktop
      }}
      id="header-site-menu"
    >
      <Toolbar sx={{ justifyContent: 'space-between', px: 2 }}>
        {isMobile ? (
          <>
            <MobileMenuDrawer layout="escolaLegislativo" />
            <Typography
              variant="h1"
              component="h1"
              sx={{
                fontSize: headerTitleStyle.fontSize,
                fontWeight: headerTitleStyle.fontWeight,
                color: textColorMobile,
                textAlign: 'center'
              }}
            >
              {nome}
            </Typography>
          </>
        ) : (
          <Box sx={{ flexGrow: 1 }}>
            <DesktopMenuDrawer layout="escolaLegislativo" />
          </Box>
        )}

        <IconButton edge="end" color="inherit" title="Buscar" sx={{ ml: 2 }}>
          <SearchIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};
